__turbopack_context__.v({
  "className": "lora_6b3147f-module__02e01W__className",
});
